var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Uh-Oh!")]),_c('h3',[_vm._v(" "+_vm._s(_vm.$t('networkIssue'))+" ")]),_c('a',{attrs:{"href":"//expar.si"}},[_vm._v(_vm._s(_vm.$t('backHome')))])])}
var staticRenderFns = []

export { render, staticRenderFns }